import { Component, Vue } from 'vue-property-decorator'
import subMenu from '@/components/submenu/index.vue'

@Component({
    components: { subMenu }
})
export default class Maketing extends Vue {
    // ------ 变量 ------
    
}